import React, { FC, useMemo } from 'react';
import * as classes from './MobileMenu.module.scss';
import TimesIcon from '../../../assets/icons/inline/times.inline.svg';
import Container from '../../Common/Container/Container';
import NavList from '../NavList/NavList';
import LanguageSwitcher from '../../Common/LanguageSwitcher/LanguageSwitcher';
import ButtonIcon from '../../../assets/icons/inline/arrow-top-right-light.inline.svg';
import Button from '../../Common/Button/Button';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { NavItem } from '../../../interfaces/nav/NavMenu';
import Link from '../Link/Link';

interface Props {
  isOpen: boolean;
  closeMenuAction: () => void;
  mainMenuItems: Array<NavItem>;
  logoText: string;
}

const MobileMenu: FC<Props> = ({ isOpen, closeMenuAction, mainMenuItems, logoText }) => {
  const { t } = useTranslation();

  return useMemo(() => {
    if (isOpen) {
      return (
        <div className={classes.element}>
          <Container>
            <div className={classes.menuHeader}>
              <div className={classes.logo} onClick={closeMenuAction}>
                <Link path={'/'}>{logoText}</Link>
              </div>
              <TimesIcon onClick={closeMenuAction} className={classes.closeBtn} />
            </div>
          </Container>
          <div className={classes.menuBody}>
            <div className={classes.navMenu}>
              <div className={classes.mainMenu}>
                <NavList items={mainMenuItems} isVerticalNav className={classes.navList} itemClickAction={closeMenuAction} />
              </div>
              <LanguageSwitcher />
            </div>
            <div className={classes.actionsWrapper}>
              <Button
                icon={<ButtonIcon />}
                link={{ path: t('header.menu.getInTouch.url'), title: t('header.menu.getInTouch.title') }}
                onClick={closeMenuAction}
              >
                {t('header.menu.getInTouch.label')}
              </Button>
            </div>
          </div>
        </div>
      );
    }
    return null;
  }, [closeMenuAction, isOpen, logoText, mainMenuItems, t]);
};

export default MobileMenu;
